import * as React from "react";
const SvgCaretUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "#220C4A", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 9L6 15H18L12 9Z", fill: "" }));
export default SvgCaretUp;
